/* eslint-disable */
import _ from 'underscore';
function from(arr) {
  var obj = _.first(arr);
  return _.keys(obj || ({}));
}
export default {
  from: from
};

